import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 20000,
});

export async function submitInquiry(payload) {
  const { data } = await api.post('/inquiries', payload);
  return data;
}
